<template>
  <section class="video">
    <div class="title">
      <span>&nbsp;&nbsp;The</span>
      <br />
      <span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;Abode</span>
      <br />
      <span>&nbsp;&nbsp;Of</span>
      <br />
      <span>Peace?</span>
    </div>

    <div class="statement">
      <div class="statement__title">
        <span>In time, wind turns</span>
        <span> stones to dust.</span>
      </div>
      <div class="statement__text">
        To speak about these topics is just the first, tiny step. It’s in the hands of people to bring about a cultural shift.
      </div>
    </div>
  </section>
</template>

<script>
import { SplitText } from '@/assets/libs/SplitText';
import animations from '@/assets/animations';
import aion from '@/scripts/aion';

export default {
  name: 'VideoSection',

  data() {
    return {
      split: null,
      entered: false,
    };
  },

  mounted() {
    this.split = new SplitText(this.$el.querySelector('.statement__text'));
    aion.add(() => {
      if (
        this.$el.querySelector('.statement__text').getBoundingClientRect().top < window.innerHeight
        && !this.entered
      ) {
        this.entered = true;
        animations.get('text-enter')(this.split).play();
      }
    }, 'statement-enter');
  },
};
</script>

<style lang="scss" scoped>
.video {
  .title {
    padding-left: 100px;
    font-size: rem(360px);
    font-size: calc(360px * var(--rw));
    line-height: rem(320px);
    line-height: calc(320px * var(--rw));
    visibility: hidden;

    @include mq($until: ipadL) {
      font-size: rem(140px);
      line-height: rem(120px);
      padding-left: 50px;
    }

    @include mq($until: ipadP) {
      font-size: rem(100px);
      line-height: rem(80px);
      padding-left: 20px;
    }
  }

  .statement {
    margin-left: 40%;
    width: 550px;
    margin-top: calc(300px * var(--rw));

    @include mq($until: ipadL) {
      width: 60%;
      margin-top: 280px;
      margin-right: auto;
      margin-left: auto;
      padding: 0px 60px;
    }

    @include mq($until: ipadP) {
      width: 70%;
      padding: 0px 25px;
    }

    &__title {
      font-size: rem(80px);
      line-height: rem(72px);

      @include mq($until: ipadL) {
        font-size: rem(50px);
        line-height: rem(42px);
      }

      @include mq($until: ipadP) {
        font-size: rem(40px);
        font-size: rem(32px);
      }
    }

    &__text {
      font-family: 'GT America Mono';
      font-size: rem(20px);
      line-height: rem(34px);
      margin-top: 80px;

      @include mq($until: ipadL) {
        margin-top: 40px;
      }
    }
  }
}
</style>
